// File: component-filters.js
// Desktop filter functionality for Shopify

const ShopifyFilters = (() => {
  let activeDropdown = null;
  
  function initDesktopFilters(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;
    
    // Setup filter buttons
    const filterButtons = container.querySelectorAll('[data-filter-trigger]');
    filterButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        const dropdown = this.nextElementSibling;
        
        // Close other dropdowns
        if (activeDropdown && activeDropdown !== dropdown) {
          closeDropdown(activeDropdown);
        }
        
        // Toggle current dropdown
        if (dropdown.classList.contains('show')) {
          closeDropdown(dropdown);
        } else {
          openDropdown(this, dropdown);
        }
      });
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', () => {
      if (activeDropdown) {
        closeDropdown(activeDropdown);
      }
    });
    
    // Prevent dropdown from closing when clicking inside
    container.querySelectorAll('[data-filter-dropdown]').forEach(dropdown => {
      dropdown.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    });
    
    // Handle price range apply button
    container.querySelectorAll('[data-apply-price]').forEach(button => {
      button.addEventListener('click', function() {
        const priceFilter = this.closest('.price-filter');
        const minInput = priceFilter.querySelector('.input-min');
        const maxInput = priceFilter.querySelector('.input-max');
        
        // Get values
        const minValue = minInput.value;
        const maxValue = maxInput.value;
        
        // Build URL parameters
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        
        if (minValue) {
          params.set(minInput.name, `${minValue}`);
        } else {
          params.delete(minInput.name);
        }
        
        if (maxValue) {
          params.set(maxInput.name, `${maxValue}`);
        } else {
          params.delete(maxInput.name);
        }
        
        // Navigate to filtered URL
        window.location.href = `${url.pathname}?${params.toString()}`;
      });
    });
    
    // Handle checkbox changes
    container.querySelectorAll('.dropdown-option input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        // Get current URL parameters
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        
        if (this.checked) {
          params.set(this.name, this.value);
        } else {
          // Remove this specific value
          const currentValues = params.getAll(this.name);
          const newValues = currentValues.filter(val => val !== this.value);
          params.delete(this.name);
          newValues.forEach(val => params.append(this.name, val));
        }
        
        // Navigate to new URL
        window.location.href = `${url.pathname}?${params.toString()}`;
      });
    });
  }
  
  function openDropdown(button, dropdown) {
    closeAllDropdowns();
    
    button.setAttribute('aria-expanded', 'true');
    dropdown.classList.add('show');
    activeDropdown = dropdown;
    
    // Position dropdown to avoid overflow
    positionDropdown(dropdown, button);
  }
  
  function closeDropdown(dropdown) {
    const button = dropdown.previousElementSibling;
    if (button && button.hasAttribute('data-filter-trigger')) {
      button.setAttribute('aria-expanded', 'false');
    }
    dropdown.classList.remove('show');
    if (activeDropdown === dropdown) {
      activeDropdown = null;
    }
  }
  
  function closeAllDropdowns() {
    document.querySelectorAll('[data-filter-dropdown].show').forEach(dropdown => {
      closeDropdown(dropdown);
    });
  }
  
  function positionDropdown(dropdown, button) {
    const buttonRect = button.getBoundingClientRect();
    const dropdownWidth = dropdown.offsetWidth;
    const viewportWidth = window.innerWidth;
    
    // Check if dropdown would overflow the right edge
    if (buttonRect.left + dropdownWidth > viewportWidth - 20) {
      dropdown.style.left = 'auto';
      dropdown.style.right = '0';
    } else {
      dropdown.style.left = '0';
      dropdown.style.right = 'auto';
    }
  }
  
  return {
    initDesktopFilters
  };
})();

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on desktop
    if (window.innerWidth >= 990) {
      document.querySelectorAll('[data-section-id]').forEach(section => {
        const containerId = `#filtersBar-${section.dataset.sectionId}`;
        ShopifyFilters.initDesktopFilters(containerId);
      });
    }
  });
} else {
  // DOM already loaded
  if (window.innerWidth >= 990) {
    document.querySelectorAll('[data-section-id]').forEach(section => {
      const containerId = `#filtersBar-${section.dataset.sectionId}`;
      ShopifyFilters.initDesktopFilters(containerId);
    });
  }
}

// Re-initialize on resize (only if crossing desktop threshold)
let isDesktop = window.innerWidth >= 990;
window.addEventListener('resize', function() {
  const nowDesktop = window.innerWidth >= 990;
  if (nowDesktop !== isDesktop && nowDesktop) {
    // Just switched to desktop, re-initialize
    document.querySelectorAll('[data-section-id]').forEach(section => {
      const containerId = `#filtersBar-${section.dataset.sectionId}`;
      ShopifyFilters.initDesktopFilters(containerId);
    });
  }
  isDesktop = nowDesktop;
});